// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__5nf2U","header":"PatientBlock_header__32kKd","label":"PatientBlock_label__11URY","option":"PatientBlock_option__FEBAn"};